export default __webpack_public_path__ + "static/media/karate.0cbd7731.png";